<template>
  <div class="mb-4">
    <SearchInput v-model="searchRaw" />
  </div>
  <BaseInnerLoading v-if="isLoading" />

  <p v-else-if="isError" class="text-error">
    Failed to load payment requests. Please try again.
  </p>

  <p v-else-if="data && items.length === 0">
    No payment requests found.
  </p>

  <ul
    v-else-if="data && items.length > 0"
    class="-mx-2 divide-y divide-background-fg/8"
  >
    <template v-for="item in items" :key="item.ident">
      <li>
        <RouterLink
          :to="{
            name: 'paymentDetail',
            params: {
              paymentRequestId: item.ident,
            },
          }"
          class="flex items-center space-x-2 py-2 text-sm hover:bg-background-fg/3"
        >
          <div class="shrink-0">
            <p class="">
              {{ DateFns.format(item.createdAt, "dd/MM") }}
            </p>
            <p class="">
              {{ DateFns.format(item.createdAt, "HH:mm") }}
            </p>
          </div>

          <div class="flex-1">
            <p class="line-clamp-1 break-all font-medium">
              {{
                item.customer.email || item.customer.phone
              }}
            </p>

            <p class="line-clamp-1 text-background-fg/70">
              {{ item.description }}
            </p>
          </div>

          <div class="shrink-0">
            <div class="text-right text-lg font-medium">
              {{ formatToCurrencyString(item.amountGross) }}
            </div>

            <div class="flex items-center justify-end">
              <PaymentStatusChip :status="item.status" />
            </div>
          </div>
        </RouterLink>
      </li>
    </template>
  </ul>

  <div
    v-if="data && items.length > 0"
    class="mt-4 flex justify-center"
  >
    <BasePagination
      v-model="page"
      :page-count="pageCount"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  customerId?: string
}>()

const searchRaw = ref<string>("")
const search = refDebounced(searchRaw, 750)

const filters = reactiveComputed(() => ({
  search: search.value?.trim(),
  customerId: props.customerId,
}))
const { pagination, page, pageCount, resetPagination } =
  usePagination({
    limit: 10,
    count: computed(() => data.value?.count || 0),
  })

watch(
  () => filters,
  () => resetPagination(),
  { deep: true, immediate: true }
)

const query = reactiveComputed(() => ({
  ...pagination.value,
  ...filters,
}))

const { data, isLoading, isError } =
  usePaymentRequests(query)

const items = computed(() => data.value?.items ?? [])
</script>
